import React, { Suspense, lazy } from 'react';
import { Switch, Route, Redirect, Link } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import RenderAuthorized from 'ant-design-pro/lib/Authorized';
// import cookies from 'js-cookie';
import { Alert, Spin, Result, Button, notification } from 'antd';
import { SmileOutlined, SyncOutlined } from '@ant-design/icons';
import { get, post } from '@/Libs/Request/index';
import Cookie from 'js-cookie';

import Orders from './Pages/Orders/Orders';
const OrdersAction = lazy(() => import('./Pages/Orders/OrdersAction'));
const OrdersAd = lazy(() => import('./Pages/Orders/Ad'));
const OrdersExport = lazy(() => import('./Pages/OrdersExport'));
const OrdersRefunds = lazy(() => import('./Pages/Orders/Refunds'));
const Groups = lazy(() => import('./Pages/Orders/Groups'));
const GroupsAction = lazy(() => import('./Pages/Orders/GroupsAction'));
const GroupsPrint = lazy(() => import('./Pages/Orders/GroupsPrint'));

// import OrdersGroupNoManagement from './Pages/OrdersGroupNoManagement';

const Tickets = lazy(() => import('./Pages/Tickets'));
const TicketsStock = lazy(() => import('./Pages/Tickets/Stock'));
const TicketsInstructio = lazy(() => import('./Pages/Tickets/Instructio'));
const Products = lazy(() => import('./Pages/Products'));
const ProductsAction = lazy(() => import('./Pages/ProductsAction'));
const ProductsView = lazy(() => import('./Pages/ProductsView'));
const ProductsPaymentRequisition = lazy(() => import('./Pages/Products/PaymentRequisition'));
const ProductsReceiptInvoice = lazy(() => import('./Pages/Products/ReceiptInvoice'));
const Supplier = lazy(() => import('./Pages/Supplier'));
const SupplierAction = lazy(() => import('./Pages/SupplierAction'));
const SupplierView = lazy(() => import('./Pages/SupplierView'));

// import PurchaseList from './Pages/Purchase/PurchaseList';
// import PurchaseAction from './Pages/Purchase/PurchaseAction';
// import PurchaseListTemplate from './Pages/Purchase/PurchaseListTemplate';

const AccountReconciliationSupplier = lazy(() => import('./Pages/AccountReconciliationSupplier'));
const OperatorAccountReconciliationSupplierGeneralLedger = lazy(() => import("./Pages/Operator/AccountReconciliationSupplierGeneralLedger"));
const OperatorAccountReconciliationSupplierSubsidiaryLedger = lazy(() => import("./Pages/Operator/AccountReconciliationSupplierSubsidiaryLedger"));
const OperatorCheckAccounts = lazy(() => import("./Pages/Operator/CheckAccounts"));
const OperatorCheckAccountsPro1 = lazy(() => import("./Pages/Operator/CheckAccountsPro1"));
const OperatorCheckAccountsPro2 = lazy(() => import("./Pages/Operator/CheckAccountsPro2"));
const OperatorOrders = lazy(() => import("./Pages/Operator/Orders"));

const ReportIndex = lazy(() => import("./Pages/Report/"));
const ReportOrders = lazy(() => import("./Pages/Report/Orders"));
const ReportTCTOrders = lazy(() => import("./Pages/Report/TCTOrders"));
const ReportDepartmentMonthIncomes = lazy(() => import("./Pages/Report/DepartmentMonthIncomes"));
const ReportDepartmentMonthIncomesFd = lazy(() => import("./Pages/Report/DepartmentMonthIncomesFd"));
const ReportROI = lazy(() => import("./Pages/Report/Roi"));

const StaDashboard = lazy(() => import("./Pages/Report/Dashboard"));
const StaCrm = lazy(() => import("./Pages/Report/Crm"));
const Traveller = lazy(() => import("./Pages/Report/Traveller"));
const Statistics = lazy(() => import("./Pages/Report/Statistics"));
const StaIndividual = lazy(() => import("./Pages/Report/Individual"));

const EnterpriseCheckAccounts = lazy(() => import("./Pages/Enterprise/CheckAccounts"));
const EnterprisePaymentRequisition = lazy(() => import("./Pages/Enterprise/PaymentRequisition"));
const EnterpriseSubsidiaryLedger = lazy(() => import("./Pages/Enterprise/SubsidiaryLedger"));
const EnterpriseSOAMBill = lazy(() => import("./Pages/Enterprise/SettlementOfAccount/MBill"));
const EnterpriseSOAAmountsReceivable = lazy(() => import("./Pages/Enterprise/SettlementOfAccount/AmountsReceivable"));
const EnterpriseSOAAccountPayable = lazy(() => import("./Pages/Enterprise/SettlementOfAccount/AccountPayable"));
const EnterpriseSOAInvoices = lazy(() => import("./Pages/Enterprise/SettlementOfAccount/Invoices"));
const EnterpriseProfit = lazy(() => import("./Pages/Enterprise/Profit"));
const EnterpriseBillManualClaim = lazy(() => import("./Pages/Enterprise/SettlementOfAccount/ManualClaim"));
const EnterpriseBillFinancialClaim = lazy(() => import("./Pages/Enterprise/SettlementOfAccount/FinancialClaim"));

const EnterpriseReportsSubsidiaryLedger = lazy(() => import("./Pages/Enterprise/Reports/SubsidiaryLedger"));
const EnterpriseReportsAccountPayable = lazy(() => import("./Pages/Enterprise/Reports/AccountPayable"));
const EnterpriseReportsAmountsReceivable = lazy(() => import("./Pages/Enterprise/Reports/AmountsReceivable"));
const EnterpriseReportsPredictLedger = lazy(() => import("./Pages/Enterprise/Reports/PredictLedger"));
const EnterpriseReportsTools = lazy(() => import("./Pages/Enterprise/Reports/Tools/index"));
const EnterpriseU8Tools = lazy(() => import("./Pages/Enterprise/Reports/Tools/u8"));

const SupplierPlatformApp = lazy(() => import("./Pages/SupplierPlatform/App"));

const Users = lazy(() => import('./Pages/Users'));
const TLogin = lazy(() => import('./Pages/TLogin'));
const Test = lazy(() => import("./Page/Test"));
const Test1 = lazy(() => import("./Page/Test1"));

const Authorized = RenderAuthorized(() => {
  // const userRolesStr = localStorage.getItem('userRoles') || '';
  const userRolesStr = Cookie.get('userRoles') || '';
  if (userRolesStr !== '') {
    return 'user';
  }
  return 'guest';
});

const AuthorizedRoute = Authorized.AuthorizedRoute;

export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginCheck: false
    }
  }

  render() {
    const self = this;
    // autoLogin(() => { });
    // <AuthorizedSalesman authority={e => checkPermissions(e)} noMatch={<Redirect from="/" to="/403/" />}>
    // checkPermissions('user-salesman')
    return (
      <ErrorBoundary>
        <Suspense fallback={<div style={{ marginTop: '50px', textAlign: 'center' }} ><Spin size="large" /></div>}>
          <Switch>
            <Route exact strict path='/login/' component={TLogin} />
            {/* <Route exact strict path='/test/' component={Test} />
          <Route exact strict path='/test1/' component={Test1} /> */}
            {/*}
          <Route exact strict path='/purchase/purchase-list/' component={PurchaseList} />
          <Route exact strict path='/purchase/purchase-list/:id' component={PurchaseAction} />
          <Route exact strict path='/purchase/purchase-list-template/' component={PurchaseListTemplate} />
          */}
            {/* <Route exact strict path='/supplier-platform/' component={SupplierPlatformApp} /> */}


            <Route exact strict path='/403/' component={() => <Result status="403" title="403" subTitle="没有权限." extra={<Button type="primary" onClick={() => { window.history.go(-1); }}>Back</Button>} />} />

            <AuthorizedRoute authority={() => checkPermissions('user-salesman')} exact strict redirectPath='/403/' path='/orders-bill/manualclaim' component={EnterpriseBillManualClaim} />

            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/orders/action/:id' component={OrdersAction} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/orders/action/' component={OrdersAction} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/orders/export/' component={OrdersExport} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/orders/:error/:page' component={Orders} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/orders/:page' component={Orders} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/orders/' component={Orders} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/orders/ad/' component={OrdersAd} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/orders/refunds/' component={OrdersRefunds} />

            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/orders/groups/print/:id' component={GroupsPrint} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/orders/groups/action/:id' component={GroupsAction} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/orders/groups/action/' component={GroupsAction} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/orders/groups/' component={Groups} />

            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/report/crm/' component={StaCrm} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/report/crm/traveller/:page' component={Traveller} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/report/statistics/:group/:key_id' component={StaIndividual} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/report/statistics/:group' component={Statistics} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/report/statistics/' component={StaDashboard} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/report/all/' component={ReportOrders} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/report/tct/' component={ReportTCTOrders} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/report/roi/' component={ReportROI} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/report/department-month-incomes/' component={ReportDepartmentMonthIncomes} />
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/report/department-month-incomes-fd/' component={ReportDepartmentMonthIncomesFd} />
            {/* <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/report/:platform/:dividersid/:shopid/' component={ReportOrders} /> */}
            <AuthorizedRoute authority={() => checkPermissions(['user-salesman'])} exact strict redirectPath='/403/' path='/report/' component={ReportIndex} />

            <AuthorizedRoute authority={() => checkPermissions('user-product')} exact strict redirectPath='/403/' path='/products/supplier/view/:id' component={SupplierView} />
            <AuthorizedRoute authority={() => checkPermissions('user')} exact strict redirectPath='/403/' path='/products/supplier/action/:id' component={SupplierAction} />
            <AuthorizedRoute authority={() => checkPermissions('user')} exact strict redirectPath='/403/' path='/products/supplier/action/' component={SupplierAction} />
            <AuthorizedRoute authority={() => checkPermissions('user')} exact strict redirectPath='/403/' path='/products/supplier/:page' component={Supplier} />
            <AuthorizedRoute authority={() => checkPermissions('user')} exact strict redirectPath='/403/' path='/products/supplier/' component={Supplier} />
            <AuthorizedRoute authority={() => checkPermissions('user-operator')} exact strict redirectPath='/403/' path='/products/payment-requisition/' component={ProductsPaymentRequisition} />
            <AuthorizedRoute authority={() => checkPermissions('user-product')} exact strict redirectPath='/403/' path='/products/receipt-invoice/' component={ProductsReceiptInvoice} />

            <AuthorizedRoute authority={() => checkPermissions('user-product')} exact strict redirectPath='/403/' path='/tickets/instructio/' component={TicketsInstructio} />
            <AuthorizedRoute authority={() => checkPermissions('user-product')} exact strict redirectPath='/403/' path='/tickets/stock/:etId' component={TicketsStock} />
            <AuthorizedRoute authority={() => checkPermissions('user-product')} exact strict redirectPath='/403/' path='/tickets/' component={Tickets} />
            <AuthorizedRoute authority={() => checkPermissions('user-product')} exact strict redirectPath='/403/' path='/products/view/:id' component={ProductsView} />
            <AuthorizedRoute authority={() => checkPermissions('user-product')} exact strict redirectPath='/403/' path='/products/action/:id' component={ProductsAction} />
            <AuthorizedRoute authority={() => checkPermissions('user-product')} exact strict redirectPath='/403/' path='/products/action/' component={ProductsAction} />
            <AuthorizedRoute authority={() => checkPermissions('user-product')} exact strict redirectPath='/403/' path='/products/:page' component={Products} />
            <AuthorizedRoute authority={() => checkPermissions('user-product')} exact strict redirectPath='/403/' path='/products/' component={Products} />

            {/*
          <AuthorizedRoute authority={() => checkPermissions('user-operator')} exact strict redirectPath='/403/' path='/operator/account-reconciliation/supplier/:page' component={AccountReconciliationSupplier} />
          <AuthorizedRoute authority={() => checkPermissions('user-operator')} exact strict redirectPath='/403/' path='/operator/account-reconciliation/supplier/' component={AccountReconciliationSupplier} />
          <AuthorizedRoute authority={() => checkPermissions('user-operator')} exact strict redirectPath='/403/' path='/operator/legder/supplier/cost-adjustment/' component={CostAdjustmentSupplier} />
          */}

            <AuthorizedRoute authority={() => checkPermissions('user-operator')} exact strict redirectPath='/403/' path='/operator/account-reconciliation/supplier/:page' component={AccountReconciliationSupplier} />
            <AuthorizedRoute authority={() => checkPermissions('user-operator')} exact strict redirectPath='/403/' path='/operator/account-reconciliation/supplier/' component={AccountReconciliationSupplier} />
            <AuthorizedRoute authority={() => checkPermissions('user-operator')} exact strict redirectPath='/403/' path='/operator/bill/supplier/account-reconciliation/:type/:id' component={OperatorAccountReconciliationSupplierSubsidiaryLedger} />
            <AuthorizedRoute authority={() => checkPermissions('user-operator')} exact strict redirectPath='/403/' path='/operator/check-accounts/' component={OperatorCheckAccounts} />
            <AuthorizedRoute authority={() => checkPermissions('user-operator')} exact strict redirectPath='/403/' path='/operator/check-accounts-pro/1/' component={OperatorCheckAccountsPro1} />
            <AuthorizedRoute authority={() => checkPermissions('user-operator')} exact strict redirectPath='/403/' path='/operator/check-accounts-pro/2/' component={OperatorCheckAccountsPro2} />
            <AuthorizedRoute authority={() => checkPermissions('user-operator')} exact strict redirectPath='/403/' path='/operator/orders/' component={OperatorOrders} />

            {/* <AuthorizedRoute authority={() => checkPermissions('user-operator')} exact strict redirectPath='/403/' path='/operator/itinerary-arrangment/' component={OperatorItineraryArrangment} /> */}

            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/bill/ad/' component={OperatorAccountReconciliationSupplierGeneralLedger} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/check-accounts/' component={EnterpriseCheckAccounts} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/payment-requisition/' component={EnterprisePaymentRequisition} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/subsidiary-ledger/' component={EnterpriseSubsidiaryLedger} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/profit/' component={EnterpriseProfit} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/settlement-of-account/amounts-receivable/' component={EnterpriseSOAAmountsReceivable} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/settlement-of-account/account-payable/' component={EnterpriseSOAAccountPayable} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/settlement-of-account/invoices/' component={EnterpriseSOAInvoices} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/settlement-of-account/mbill/claim/:id' component={EnterpriseBillManualClaim} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/settlement-of-account/mbill/financialclaim' component={EnterpriseBillFinancialClaim} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/settlement-of-account/mbill/:type' component={EnterpriseSOAMBill} />

            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/reports/subsidiary-ledger/' component={EnterpriseReportsSubsidiaryLedger} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/reports/predict-ledger/' component={EnterpriseReportsPredictLedger} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/reports/account-payable/' component={EnterpriseReportsAccountPayable} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/reports/amounts-receivable/' component={EnterpriseReportsAmountsReceivable} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/reports/tools/' component={EnterpriseReportsTools} />
            <AuthorizedRoute authority={() => checkPermissions('user-finance')} exact strict redirectPath='/403/' path='/enterprise/reports/tools/u8' component={EnterpriseU8Tools} />

            <AuthorizedRoute authority={() => checkPermissions('admin')} exact strict redirectPath='/403/' path='/users/' component={Users} />
          </Switch>
        </Suspense>
      </ErrorBoundary>
    );
  }
}

/*<Route exact strict path='/' component={Home} /> */
const seconds = 60 * 60 * 12; // 小时
const COOKIE_EXPIRES = new Date(new Date() * 1 + seconds * 1000);

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info);
    console.log((error, info));
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Result
          status="warning"
          title="Sorry, something went wrong."
          extra={[
            <Button key={'home'}
              type="primary"
              onClick={() => {
                createBrowserHistory().push('/#/orders/1');
                window.history.go(0);
              }}
            >
              Back Home
            </Button>,
            <Button icon={<SyncOutlined />}
              type="primary" ghost key={'reload'}
              onClick={() => {
                window.location.reload(true);
              }}
            >
              Reload
            </Button>]
          }
        />
      );
    }
    return this.props.children;
  }
}

function autoLogin(cb) {
  // const username = localStorage.getItem('username') || '';
  // const userId = localStorage.getItem('userId') || '';
  // const userToken = localStorage.getItem('userToken') || '';
  // const userRoles = localStorage.getItem('userRoles') || '';
  // const dividersIdCurrent = localStorage.getItem('dividersIdCurrent') || '';

  const username = Cookie.get('username') || '';
  const userId = Cookie.get('userId') || '';
  const userToken = Cookie.get('userToken') || '';
  const userRoles = Cookie.get('userRoles') || '';
  const dividersIdCurrent = Cookie.get('dividersIdCurrent') || '';
  if (userId === '' || userToken === '' || userRoles === '' || dividersIdCurrent === '') {
    // log back in
    if (window.location.href.indexOf('/login/') < 0) {
      createBrowserHistory().push('/#/login/');
      window.history.go(0);
    }
  } else {
    createBrowserHistory().push('/#/login/');
    window.history.go(0);
    return;
    notification.open({
      message: '自动登录中...',
      icon: (
        <SmileOutlined
          style={{
            color: '#108ee9',
          }}
        />
      ),
    });
    post(`/security/user/auto-login`, { username, userToken })
      .then(response => response.json())
      .then((body) => {
        if (body.errno === 0) {
          // 刷新
          window.history.go(0);
          setStorage(body.data);
          cb(null, body);
        } else if (body.errno === 3) {
          if (window.location.href.indexOf('/403/') < 0) {
            // createBrowserHistory().push('/#/403/');
            // window.history.go(0);
            // cb(body.errno);
          }
        } else {
          localStorage.setItem('userId', '');
          localStorage.setItem('username', '');
          localStorage.setItem('realname', '');
          localStorage.setItem('userToken', '');
          localStorage.setItem('userRoles', '');
          localStorage.setItem('dividersIdCurrent', '');

          Cookie.set('userId', '');
          Cookie.set('username', '');
          Cookie.set('realname', '');
          Cookie.set('userToken', '');
          Cookie.set('userRoles', '');
          Cookie.set('dividersIdCurrent', '');
          cb('err', body);
        }
        // log back in login page
      })
      .catch((signal) => { });
  }
}

function setStorage(user) {
  const roles = user.roles_info.map(item => item.role);
  localStorage.setItem('userId', user.u_id);
  localStorage.setItem('username', user.username);
  localStorage.setItem('realname', user.real_name);
  localStorage.setItem('userToken', user.token);
  localStorage.setItem('userRoles', ['user'].concat(roles).join(','));
  localStorage.setItem('user_authority', 'user');
  localStorage.setItem('dividersId', user?.dividers_id || '1,2'); // 所有可用隔离id列表,逗号分隔
  localStorage.setItem('dividersIdCurrent', user.dividers_id || '1,2'); // 当前使用的id
  localStorage.setItem('yj_code', user.yj_code);

  Cookie.set('userId', user.u_id, { 'expires': COOKIE_EXPIRES });
  Cookie.set('username', user.username, { 'expires': COOKIE_EXPIRES });
  Cookie.set('realname', user.real_name, { 'expires': COOKIE_EXPIRES });
  Cookie.set('userToken', user.token, { 'expires': COOKIE_EXPIRES });
  Cookie.set('userRoles', ['user'].concat(roles).join(','), { 'expires': COOKIE_EXPIRES });
  Cookie.set('user_authority', 'user', { 'expires': COOKIE_EXPIRES });
  Cookie.set('dividersId', user?.dividers_id || '1,2', { 'expires': COOKIE_EXPIRES }); // 所有可用隔离id列表,逗号分隔
  Cookie.set('dividersIdCurrent', user.dividers_id || '1,2', { 'expires': COOKIE_EXPIRES }); // 当前使用的id
  
  Cookie.set('yj_code', user.yj_code, { 'expires': COOKIE_EXPIRES });
}

function checkPermissions(role) {
  // const userId = localStorage.getItem('userId') || '';
  // const dividersIdCurrent = localStorage.getItem('dividersIdCurrent') || '';

  const userId = Cookie.get('userId') || '';
  const dividersIdCurrent = Cookie.get('dividersIdCurrent') || '';
  if (typeof role === 'string') role = [role];
  if (userId === '' || dividersIdCurrent === '') {
    autoLogin(() => { });
    // createBrowserHistory().push('/#/login/');
  }
  if (role === '' || role === undefined || role === null) {
    return false;
  }
  return new Promise((resolve, reject) => {
    get(`/api/users/${userId}`)
      .then(response => response.json())
      .then((body) => {
        if (body.errno === 0) {
          const user = body.data;
          let check = role.includes('user');
          role.forEach(element1 => {
            user.roles_info.forEach(element2 => {
              if (['admin', 'department-manager'].includes(element2.role) >= 0) {
                check = true;
              }
              if (element2.role === element1) {
                check = true;
              }
            });
          });
          const roles = user.roles_info.map(item => item.role);
          // localStorage.setItem('userRoles', ['user'].concat(roles).join(','));
          Cookie.set('userRoles', ['user'].concat(roles).join(','),  { 'expires': COOKIE_EXPIRES });
          // setStorage(user);
          return check === true ? resolve() : reject('403');
        } else {
          autoLogin(() => { });
        }
      }).catch(err => {
        autoLogin(() => { });
      });
  });
}
